<div class="legend-container" [style.width]="width + 2 +'px'">
  <img [src]="source" class="legend">

  <div class="legend-values">
    @for (entry of valuesEntries; track entry) {
<div class="legend-value" [style.left]="entry.position * 100 +'%'">
      <div class="legend-label">{{ entry.label | label | async }}</div>
      <div class="legend-mark" [style.height]="height + 8 +'px'"></div>
    </div>
}
  </div>
</div>
